import { render, staticRenderFns } from "./khach-hang-tu-van.vue?vue&type=template&id=9b87d9f8"
import script from "./khach-hang-tu-van.vue?vue&type=script&lang=js"
export * from "./khach-hang-tu-van.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports